<div class="modal-content-wrapper">
  <header></header>
  <section><ng-template #modalHolder appModalHolder></ng-template></section>
  <footer>
    <div class="modal-button-row">
      <input type="button" [hidden]="closeHidden" style="margin:10px;" id="btnCloseModal" class="primary-blue-button blue cancel" [ngClass]="{'buttonDisabled':CloseButtonDisabled}" [disabled]="CloseButtonDisabled" (click)="closeMethod()" value="Back" />
      <input type="button" [hidden]="acceptHidden" style="margin:10px;" id="btnActionModal" class="primary-blue-button blue continue" [ngClass]="{'buttonDisabled':ActionButtonDisabled}" [disabled]="ActionButtonDisabled" (click)="actionMethod()" value="Accept" />
    </div>
  </footer>
</div>
